import { BASEPATH } from "../../utils/constants/constants";

export const DOWNLOAD_DETAILS_URL = (envVars: any) => {
  return {
    CREATE_ORDER: `${BASEPATH}/downloads/create-order`,
    DOWNLOAD_ORDER: `${BASEPATH}/downloads/download-order`,
    DOWNLOAD_REPORT: `${BASEPATH}/downloads/download-reports`,
  };
};
